export default __webpack_public_path__ + "static/media/que-step3.38a254da.gif";